import React from 'react';
import { Filter } from 'lucide-react';

const accentStyles = {
  default: 'text-slate-900',
  success: 'text-emerald-600',
  danger: 'text-red-600',
  warning: 'text-orange-500',
  muted: 'text-slate-500',
};

const StatCard = ({ value, label, icon: Icon, accent, onClick, isActive }) => {
  const isClickable = !!onClick;

  return (
    <div
      onClick={onClick}
      className={`bg-white rounded-lg p-5 shadow-sm border transition-all ${
        isActive
          ? 'border-emerald-500 ring-2 ring-emerald-100'
          : 'border-slate-200'
      } ${
        isClickable ? 'cursor-pointer hover:border-slate-300 hover:shadow-md active:scale-[0.98]' : ''
      }`}
    >
      <div className="flex items-start justify-between">
        <div>
          <div className="flex items-center gap-2 mb-1">
            <p className="text-[11px] font-semibold text-slate-500 uppercase tracking-wider">
              {label}
            </p>
            {isActive && (
              <span className="flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] font-medium bg-emerald-100 text-emerald-700">
                <Filter className="h-2.5 w-2.5" />
                Filtered
              </span>
            )}
          </div>
          <p className={`text-3xl font-bold tracking-tight ${accentStyles[accent] || accentStyles.default}`}>
            {value}
          </p>
        </div>
        {Icon && (
          <Icon className={`h-5 w-5 ${isActive ? 'text-emerald-500' : accent === 'success' ? 'text-emerald-500' : accent === 'danger' ? 'text-red-500' : accent === 'warning' ? 'text-orange-500' : 'text-slate-400'}`} strokeWidth={1.5} />
        )}
      </div>
    </div>
  );
};

export default StatCard;
